import { BREW_DEMO_BOOKING_URL } from '@/lib/site/booking'

/** Copy for the founders widget (Paper "Founders card — v2 (illustration)"). */
export const FOUNDERS_WIDGET = {
  title: 'Talk to the founders',
  body: "Tell us what emails you send and we'll build the first one with you.",
  cta: 'Book a demo',
  /** The speech bubble beside the collapsed launcher. */
  bubble: "Let's chat",
  /** The Brew demo booking page on Cal.com. */
  href: BREW_DEMO_BOOKING_URL,
  /** Resting drawing: handset on the phone. */
  imageRest: '/landing/home/founders/founders-rest.png',
  /** Hover drawing: Thomas lifts the handset to his ear. */
  imageUp: '/landing/home/founders/founders-up.png',
  /** Real photos for the collapsed launcher; one is picked per page view. */
  photos: {
    philip: '/people/philip_sorensen.png',
    thomas: '/people/thomas_park.jpeg',
  },
  imageAlt:
    'Philip and Thomas, drawn in pencil, holding an orange rotary phone.',
} as const
